import { IContact } from "../interface";

export class IContactFactory {
  static new(props: IContact): IContact {
    return {
      ...props
    }
  }
}
